



import { defineAsyncComponent, defineComponent } from '@nuxtjs/composition-api';
import { gql } from 'graphql-tag';

import { contentableBlockColorFragment } from '@/composables/block-color';

import { largeImageFragment, medium1x1ImageFragment } from '@/graphql/queries/image.fragments';

export default defineComponent({
  components: {
    Page: defineAsyncComponent(() => import('@/pages/shows/_slug.vue')),
  },
  graphqlData: gql`
    fragment ScenkonstOtPerformanceContentData on ScenkonstOtPerformanceContent {
      id
      title
      subtitle
      about
      factBoxes {
        title
        text
      }
      archived
      trailerId
      trailerLength
      status
      startDate
      endDate
      showCalendar
      disclaimer {
        title
        lead
        linkText
        linkUrl
      }
      performanceStaffs {
        staff {
          id
          firstName
          lastName
          pageUrl
          shouldLink
          category {
            id
            name
          }
          image {
            ...Medium1x1ImageData
          }
        }
        role
      }
      artisticTeams {
        role
        names
      }
      musicians {
        role
        names
      }
      customAppearence
      reviews {
        quote
        who
      }
      image {
        ...LargeImageData
      }
      videoLoopUrl
      blocks {
        __typename @inject
      }
      dynamicBlockContainers {
        id
        title
        blocks {
          __typename @inject
        }
      }
      ...ContentableBlockColor
    }

    ${largeImageFragment}
    ${medium1x1ImageFragment}
    ${contentableBlockColorFragment}
  `,
});
